import { render, staticRenderFns } from "./PromotedBuyBox.vue?vue&type=template&id=329b64fa&scoped=true"
import script from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedBuyBox.vue?vue&type=style&index=0&id=329b64fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b64fa",
  null
  
)

export default component.exports